module.exports = __webpack_public_path__ + "img/special2-4.ed0f3d2a.png";